"use strict";
/*
 * Created on 09 10 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var RoundedProductPrice_1 = require("./RoundedProductPrice");
/**
 * <p>Superclass for rounded product prices with required {@link RoundedProductPrice.value}.</p>
 *
 * @author Jaroslav Sevcik
 */


var RoundedProductPriceRequired =
/*#__PURE__*/
function (_RoundedProductPrice_) {
  _inherits(RoundedProductPriceRequired, _RoundedProductPrice_);

  /**
   * Ctor.
   *
   * @param value Corresponds to {@link RoundedProductPrice.value}, but value is required.
   * @param valueRounded Corresponds to {@link RoundedProductPrice.valueRounded}.
   */
  function RoundedProductPriceRequired(value, valueRounded) {
    var _this;

    _classCallCheck(this, RoundedProductPriceRequired);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RoundedProductPriceRequired).call(this, value, valueRounded));
    _this.value = value;
    _this.valueRounded = valueRounded;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(RoundedProductPriceRequired, [{
    key: "getPresentedValue",
    value: function getPresentedValue() {
      return this.valueRounded || this.value;
    }
  }]);

  return RoundedProductPriceRequired;
}(RoundedProductPrice_1.RoundedProductPrice);

exports.RoundedProductPriceRequired = RoundedProductPriceRequired;